var map = {
	"./img22-1.png": 44712,
	"./img22.png": 70899,
	"./tips.png": 35837,
	"./tips1.png": 28810,
	"./tips10.png": 94126,
	"./tips11.png": 91205,
	"./tips12.png": 89549,
	"./tips2.png": 6722,
	"./tips3.png": 54485,
	"./tips4.png": 92427,
	"./tips5.png": 22725,
	"./tips6.png": 19223,
	"./tips7.png": 2732,
	"./tips8.png": 42946,
	"./tips9.png": 32571
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 56716;